import {Component} from '@angular/core';

@Component({
  templateUrl: './email-is-changed.component.html'
})
export class EmailIsChangedComponent {
}
